import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const PercentageButtonsSliderIcon = ({ onClick, ...rest }: SvgIconProps & { onClick: () => void }) => {
  return (
    <SvgIcon
      {...rest}
      className="text-t300 ml-2 cursor-pointer stroke-0 transition-all duration-300 hover:brightness-125"
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13L16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11L8 11Z"
        fill="currentColor"
      ></path>
    </SvgIcon>
  )
}
